/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { PlatformFramework } from '../model';
// @ts-ignore
import type { PolicyTemplate } from '../model';
// @ts-ignore
import type { PolicyTemplateCreate } from '../model';
// @ts-ignore
import type { PolicyTemplateExpandedSorting } from '../model';
// @ts-ignore
import type { PolicyTemplateOverviewPaginated } from '../model';
// @ts-ignore
import type { PolicyTemplatePaginated } from '../model';
// @ts-ignore
import type { PolicyTemplateSorting } from '../model';
// @ts-ignore
import type { PolicyTemplateStatus } from '../model';
// @ts-ignore
import type { PolicyTemplateStatusUpdate } from '../model';
// @ts-ignore
import type { PolicyTemplateVersion } from '../model';
// @ts-ignore
import type { PolicyTemplateVersionCreate } from '../model';
// @ts-ignore
import type { PolicyTemplateVersionFrameworkUpdate } from '../model';
// @ts-ignore
import type { PolicyTemplateVersionFrameworksUpdate } from '../model';
// @ts-ignore
import type { PolicyTemplateVersionPaginated } from '../model';
// @ts-ignore
import type { PolicyTemplateVersionSorting } from '../model';
// @ts-ignore
import type { PolicyTemplateVersionStatus } from '../model';
// @ts-ignore
import type { PolicyTemplateVersionStatusUpdate } from '../model';
// @ts-ignore
import type { PolicyTemplateVersionUpdate } from '../model';
/**
 * PolicyTemplatesApi - axios parameter creator
 */
export const PolicyTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add Framework to Policy Template Version
         * @param {string} policyTemplateId 
         * @param {string} policyTemplateVersionId 
         * @param {PolicyTemplateVersionFrameworkUpdate} policyTemplateVersionFrameworkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlatformFramework: async (policyTemplateId: string, policyTemplateVersionId: string, policyTemplateVersionFrameworkUpdate: PolicyTemplateVersionFrameworkUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyTemplateId' is not null or undefined
            assertParamExists('addPlatformFramework', 'policyTemplateId', policyTemplateId)
            // verify required parameter 'policyTemplateVersionId' is not null or undefined
            assertParamExists('addPlatformFramework', 'policyTemplateVersionId', policyTemplateVersionId)
            // verify required parameter 'policyTemplateVersionFrameworkUpdate' is not null or undefined
            assertParamExists('addPlatformFramework', 'policyTemplateVersionFrameworkUpdate', policyTemplateVersionFrameworkUpdate)
            const localVarPath = `/policy-templates/{policy_template_id}/versions/{policy_template_version_id}/platform-frameworks`
                .replace('{policy_template_id}', encodeURIComponent(String(policyTemplateId)))
                .replace('{policy_template_version_id}', encodeURIComponent(String(policyTemplateVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyTemplateVersionFrameworkUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Policy Template
         * @param {PolicyTemplateCreate} policyTemplateCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyTemplate: async (policyTemplateCreate: PolicyTemplateCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyTemplateCreate' is not null or undefined
            assertParamExists('createPolicyTemplate', 'policyTemplateCreate', policyTemplateCreate)
            const localVarPath = `/policy-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyTemplateCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Policy Template Version
         * @param {string} policyTemplateId 
         * @param {PolicyTemplateVersionCreate} policyTemplateVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyTemplateVersion: async (policyTemplateId: string, policyTemplateVersionCreate: PolicyTemplateVersionCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyTemplateId' is not null or undefined
            assertParamExists('createPolicyTemplateVersion', 'policyTemplateId', policyTemplateId)
            // verify required parameter 'policyTemplateVersionCreate' is not null or undefined
            assertParamExists('createPolicyTemplateVersion', 'policyTemplateVersionCreate', policyTemplateVersionCreate)
            const localVarPath = `/policy-templates/{policy_template_id}/versions`
                .replace('{policy_template_id}', encodeURIComponent(String(policyTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyTemplateVersionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Policy Template
         * @param {string} policyTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyTemplate: async (policyTemplateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyTemplateId' is not null or undefined
            assertParamExists('getPolicyTemplate', 'policyTemplateId', policyTemplateId)
            const localVarPath = `/policy-templates/{policy_template_id}`
                .replace('{policy_template_id}', encodeURIComponent(String(policyTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Policy Template Version
         * @param {string} policyTemplateVersionId 
         * @param {string} policyTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyTemplateVersion: async (policyTemplateVersionId: string, policyTemplateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyTemplateVersionId' is not null or undefined
            assertParamExists('getPolicyTemplateVersion', 'policyTemplateVersionId', policyTemplateVersionId)
            // verify required parameter 'policyTemplateId' is not null or undefined
            assertParamExists('getPolicyTemplateVersion', 'policyTemplateId', policyTemplateId)
            const localVarPath = `/policy-templates/{policy_template_id}/versions/{policy_template_version_id}`
                .replace('{policy_template_version_id}', encodeURIComponent(String(policyTemplateVersionId)))
                .replace('{policy_template_id}', encodeURIComponent(String(policyTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Policy Template Version Frameworks
         * @param {string} policyTemplateVersionId 
         * @param {string} policyTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyTemplateVersionFrameworks: async (policyTemplateVersionId: string, policyTemplateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyTemplateVersionId' is not null or undefined
            assertParamExists('getPolicyTemplateVersionFrameworks', 'policyTemplateVersionId', policyTemplateVersionId)
            // verify required parameter 'policyTemplateId' is not null or undefined
            assertParamExists('getPolicyTemplateVersionFrameworks', 'policyTemplateId', policyTemplateId)
            const localVarPath = `/policy-templates/{policy_template_id}/versions/{policy_template_version_id}/platform-frameworks`
                .replace('{policy_template_version_id}', encodeURIComponent(String(policyTemplateVersionId)))
                .replace('{policy_template_id}', encodeURIComponent(String(policyTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query Policy Template Versions
         * @param {string} policyTemplateId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicyTemplateVersionSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicyTemplateVersions: async (policyTemplateId: string, page?: number, size?: number, sortBy?: PolicyTemplateVersionSorting | null, descending?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyTemplateId' is not null or undefined
            assertParamExists('queryPolicyTemplateVersions', 'policyTemplateId', policyTemplateId)
            const localVarPath = `/policy-templates/{policy_template_id}/versions`
                .replace('{policy_template_id}', encodeURIComponent(String(policyTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query Policy Templates
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicyTemplateSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrDescription] 
         * @param {PolicyTemplateStatus | null} [status] 
         * @param {Array<string> | null} [platformFrameworkIds] Filter by platform framework IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicyTemplates: async (page?: number, size?: number, sortBy?: PolicyTemplateSorting | null, descending?: boolean | null, nameOrDescription?: string | null, status?: PolicyTemplateStatus | null, platformFrameworkIds?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/policy-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (nameOrDescription !== undefined) {
                localVarQueryParameter['name_or_description'] = nameOrDescription;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (platformFrameworkIds) {
                localVarQueryParameter['platform_framework_ids'] = platformFrameworkIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Query Policy Templates Expanded
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicyTemplateExpandedSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [createdById] 
         * @param {PolicyTemplateVersionStatus | null} [draftPolicyTemplateVersionStatus] 
         * @param {string | null} [nameOrDescription] 
         * @param {PolicyTemplateStatus | null} [status] 
         * @param {Array<string> | null} [platformFrameworkIds] Filter by platform framework IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicyTemplatesExpanded: async (page?: number, size?: number, sortBy?: PolicyTemplateExpandedSorting | null, descending?: boolean | null, createdById?: string | null, draftPolicyTemplateVersionStatus?: PolicyTemplateVersionStatus | null, nameOrDescription?: string | null, status?: PolicyTemplateStatus | null, platformFrameworkIds?: Array<string> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/policy-templates/expanded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (createdById !== undefined) {
                localVarQueryParameter['created_by_id'] = createdById;
            }

            if (draftPolicyTemplateVersionStatus !== undefined) {
                localVarQueryParameter['draft_policy_template_version_status'] = draftPolicyTemplateVersionStatus;
            }

            if (nameOrDescription !== undefined) {
                localVarQueryParameter['name_or_description'] = nameOrDescription;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (platformFrameworkIds) {
                localVarQueryParameter['platform_framework_ids'] = platformFrameworkIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Framework from Policy Template Version
         * @param {string} platformFrameworkId 
         * @param {string} policyTemplateId 
         * @param {string} policyTemplateVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePlatformFramework: async (platformFrameworkId: string, policyTemplateId: string, policyTemplateVersionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformFrameworkId' is not null or undefined
            assertParamExists('removePlatformFramework', 'platformFrameworkId', platformFrameworkId)
            // verify required parameter 'policyTemplateId' is not null or undefined
            assertParamExists('removePlatformFramework', 'policyTemplateId', policyTemplateId)
            // verify required parameter 'policyTemplateVersionId' is not null or undefined
            assertParamExists('removePlatformFramework', 'policyTemplateVersionId', policyTemplateVersionId)
            const localVarPath = `/policy-templates/{policy_template_id}/versions/{policy_template_version_id}/platform-frameworks/{platform_framework_id}`
                .replace('{platform_framework_id}', encodeURIComponent(String(platformFrameworkId)))
                .replace('{policy_template_id}', encodeURIComponent(String(policyTemplateId)))
                .replace('{policy_template_version_id}', encodeURIComponent(String(policyTemplateVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace All Frameworks of Policy Template Version
         * @param {string} policyTemplateId 
         * @param {string} policyTemplateVersionId 
         * @param {PolicyTemplateVersionFrameworksUpdate} policyTemplateVersionFrameworksUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlatformFrameworks: async (policyTemplateId: string, policyTemplateVersionId: string, policyTemplateVersionFrameworksUpdate: PolicyTemplateVersionFrameworksUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyTemplateId' is not null or undefined
            assertParamExists('updatePlatformFrameworks', 'policyTemplateId', policyTemplateId)
            // verify required parameter 'policyTemplateVersionId' is not null or undefined
            assertParamExists('updatePlatformFrameworks', 'policyTemplateVersionId', policyTemplateVersionId)
            // verify required parameter 'policyTemplateVersionFrameworksUpdate' is not null or undefined
            assertParamExists('updatePlatformFrameworks', 'policyTemplateVersionFrameworksUpdate', policyTemplateVersionFrameworksUpdate)
            const localVarPath = `/policy-templates/{policy_template_id}/versions/{policy_template_version_id}/platform-frameworks`
                .replace('{policy_template_id}', encodeURIComponent(String(policyTemplateId)))
                .replace('{policy_template_version_id}', encodeURIComponent(String(policyTemplateVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyTemplateVersionFrameworksUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Policy Template Status
         * @param {string} policyTemplateId 
         * @param {PolicyTemplateStatusUpdate} policyTemplateStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyTemplateStatus: async (policyTemplateId: string, policyTemplateStatusUpdate: PolicyTemplateStatusUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyTemplateId' is not null or undefined
            assertParamExists('updatePolicyTemplateStatus', 'policyTemplateId', policyTemplateId)
            // verify required parameter 'policyTemplateStatusUpdate' is not null or undefined
            assertParamExists('updatePolicyTemplateStatus', 'policyTemplateStatusUpdate', policyTemplateStatusUpdate)
            const localVarPath = `/policy-templates/{policy_template_id}/status`
                .replace('{policy_template_id}', encodeURIComponent(String(policyTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyTemplateStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Policy Template Version
         * @param {string} policyTemplateId 
         * @param {string} policyTemplateVersionId 
         * @param {PolicyTemplateVersionUpdate} policyTemplateVersionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyTemplateVersion: async (policyTemplateId: string, policyTemplateVersionId: string, policyTemplateVersionUpdate: PolicyTemplateVersionUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyTemplateId' is not null or undefined
            assertParamExists('updatePolicyTemplateVersion', 'policyTemplateId', policyTemplateId)
            // verify required parameter 'policyTemplateVersionId' is not null or undefined
            assertParamExists('updatePolicyTemplateVersion', 'policyTemplateVersionId', policyTemplateVersionId)
            // verify required parameter 'policyTemplateVersionUpdate' is not null or undefined
            assertParamExists('updatePolicyTemplateVersion', 'policyTemplateVersionUpdate', policyTemplateVersionUpdate)
            const localVarPath = `/policy-templates/{policy_template_id}/versions/{policy_template_version_id}`
                .replace('{policy_template_id}', encodeURIComponent(String(policyTemplateId)))
                .replace('{policy_template_version_id}', encodeURIComponent(String(policyTemplateVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyTemplateVersionUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Policy Template Version Status
         * @param {string} policyTemplateId 
         * @param {string} policyTemplateVersionId 
         * @param {PolicyTemplateVersionStatusUpdate} policyTemplateVersionStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyTemplateVersionStatus: async (policyTemplateId: string, policyTemplateVersionId: string, policyTemplateVersionStatusUpdate: PolicyTemplateVersionStatusUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyTemplateId' is not null or undefined
            assertParamExists('updatePolicyTemplateVersionStatus', 'policyTemplateId', policyTemplateId)
            // verify required parameter 'policyTemplateVersionId' is not null or undefined
            assertParamExists('updatePolicyTemplateVersionStatus', 'policyTemplateVersionId', policyTemplateVersionId)
            // verify required parameter 'policyTemplateVersionStatusUpdate' is not null or undefined
            assertParamExists('updatePolicyTemplateVersionStatus', 'policyTemplateVersionStatusUpdate', policyTemplateVersionStatusUpdate)
            const localVarPath = `/policy-templates/{policy_template_id}/versions/{policy_template_version_id}/status`
                .replace('{policy_template_id}', encodeURIComponent(String(policyTemplateId)))
                .replace('{policy_template_version_id}', encodeURIComponent(String(policyTemplateVersionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyTemplateVersionStatusUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PolicyTemplatesApi - functional programming interface
 */
export const PolicyTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PolicyTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add Framework to Policy Template Version
         * @param {string} policyTemplateId 
         * @param {string} policyTemplateVersionId 
         * @param {PolicyTemplateVersionFrameworkUpdate} policyTemplateVersionFrameworkUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPlatformFramework(policyTemplateId: string, policyTemplateVersionId: string, policyTemplateVersionFrameworkUpdate: PolicyTemplateVersionFrameworkUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplateVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPlatformFramework(policyTemplateId, policyTemplateVersionId, policyTemplateVersionFrameworkUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.addPlatformFramework']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Policy Template
         * @param {PolicyTemplateCreate} policyTemplateCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPolicyTemplate(policyTemplateCreate: PolicyTemplateCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPolicyTemplate(policyTemplateCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.createPolicyTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Policy Template Version
         * @param {string} policyTemplateId 
         * @param {PolicyTemplateVersionCreate} policyTemplateVersionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPolicyTemplateVersion(policyTemplateId: string, policyTemplateVersionCreate: PolicyTemplateVersionCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplateVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPolicyTemplateVersion(policyTemplateId, policyTemplateVersionCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.createPolicyTemplateVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Policy Template
         * @param {string} policyTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyTemplate(policyTemplateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyTemplate(policyTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.getPolicyTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Policy Template Version
         * @param {string} policyTemplateVersionId 
         * @param {string} policyTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyTemplateVersion(policyTemplateVersionId: string, policyTemplateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplateVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyTemplateVersion(policyTemplateVersionId, policyTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.getPolicyTemplateVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Policy Template Version Frameworks
         * @param {string} policyTemplateVersionId 
         * @param {string} policyTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyTemplateVersionFrameworks(policyTemplateVersionId: string, policyTemplateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlatformFramework>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyTemplateVersionFrameworks(policyTemplateVersionId, policyTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.getPolicyTemplateVersionFrameworks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Query Policy Template Versions
         * @param {string} policyTemplateId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicyTemplateVersionSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryPolicyTemplateVersions(policyTemplateId: string, page?: number, size?: number, sortBy?: PolicyTemplateVersionSorting | null, descending?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplateVersionPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryPolicyTemplateVersions(policyTemplateId, page, size, sortBy, descending, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.queryPolicyTemplateVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Query Policy Templates
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicyTemplateSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [nameOrDescription] 
         * @param {PolicyTemplateStatus | null} [status] 
         * @param {Array<string> | null} [platformFrameworkIds] Filter by platform framework IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryPolicyTemplates(page?: number, size?: number, sortBy?: PolicyTemplateSorting | null, descending?: boolean | null, nameOrDescription?: string | null, status?: PolicyTemplateStatus | null, platformFrameworkIds?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplatePaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryPolicyTemplates(page, size, sortBy, descending, nameOrDescription, status, platformFrameworkIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.queryPolicyTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Query Policy Templates Expanded
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {PolicyTemplateExpandedSorting | null} [sortBy] 
         * @param {boolean | null} [descending] 
         * @param {string | null} [createdById] 
         * @param {PolicyTemplateVersionStatus | null} [draftPolicyTemplateVersionStatus] 
         * @param {string | null} [nameOrDescription] 
         * @param {PolicyTemplateStatus | null} [status] 
         * @param {Array<string> | null} [platformFrameworkIds] Filter by platform framework IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryPolicyTemplatesExpanded(page?: number, size?: number, sortBy?: PolicyTemplateExpandedSorting | null, descending?: boolean | null, createdById?: string | null, draftPolicyTemplateVersionStatus?: PolicyTemplateVersionStatus | null, nameOrDescription?: string | null, status?: PolicyTemplateStatus | null, platformFrameworkIds?: Array<string> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplateOverviewPaginated>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryPolicyTemplatesExpanded(page, size, sortBy, descending, createdById, draftPolicyTemplateVersionStatus, nameOrDescription, status, platformFrameworkIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.queryPolicyTemplatesExpanded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove Framework from Policy Template Version
         * @param {string} platformFrameworkId 
         * @param {string} policyTemplateId 
         * @param {string} policyTemplateVersionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePlatformFramework(platformFrameworkId: string, policyTemplateId: string, policyTemplateVersionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplateVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePlatformFramework(platformFrameworkId, policyTemplateId, policyTemplateVersionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.removePlatformFramework']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace All Frameworks of Policy Template Version
         * @param {string} policyTemplateId 
         * @param {string} policyTemplateVersionId 
         * @param {PolicyTemplateVersionFrameworksUpdate} policyTemplateVersionFrameworksUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlatformFrameworks(policyTemplateId: string, policyTemplateVersionId: string, policyTemplateVersionFrameworksUpdate: PolicyTemplateVersionFrameworksUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplateVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlatformFrameworks(policyTemplateId, policyTemplateVersionId, policyTemplateVersionFrameworksUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.updatePlatformFrameworks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Policy Template Status
         * @param {string} policyTemplateId 
         * @param {PolicyTemplateStatusUpdate} policyTemplateStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePolicyTemplateStatus(policyTemplateId: string, policyTemplateStatusUpdate: PolicyTemplateStatusUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePolicyTemplateStatus(policyTemplateId, policyTemplateStatusUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.updatePolicyTemplateStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Policy Template Version
         * @param {string} policyTemplateId 
         * @param {string} policyTemplateVersionId 
         * @param {PolicyTemplateVersionUpdate} policyTemplateVersionUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePolicyTemplateVersion(policyTemplateId: string, policyTemplateVersionId: string, policyTemplateVersionUpdate: PolicyTemplateVersionUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplateVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePolicyTemplateVersion(policyTemplateId, policyTemplateVersionId, policyTemplateVersionUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.updatePolicyTemplateVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Policy Template Version Status
         * @param {string} policyTemplateId 
         * @param {string} policyTemplateVersionId 
         * @param {PolicyTemplateVersionStatusUpdate} policyTemplateVersionStatusUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePolicyTemplateVersionStatus(policyTemplateId: string, policyTemplateVersionId: string, policyTemplateVersionStatusUpdate: PolicyTemplateVersionStatusUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyTemplateVersion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePolicyTemplateVersionStatus(policyTemplateId, policyTemplateVersionId, policyTemplateVersionStatusUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolicyTemplatesApi.updatePolicyTemplateVersionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PolicyTemplatesApi - factory interface
 */
export const PolicyTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PolicyTemplatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Add Framework to Policy Template Version
         * @param {PolicyTemplatesApiAddPlatformFrameworkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlatformFramework(requestParameters: PolicyTemplatesApiAddPlatformFrameworkRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplateVersion> {
            return localVarFp.addPlatformFramework(requestParameters.policyTemplateId, requestParameters.policyTemplateVersionId, requestParameters.policyTemplateVersionFrameworkUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Policy Template
         * @param {PolicyTemplatesApiCreatePolicyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyTemplate(requestParameters: PolicyTemplatesApiCreatePolicyTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplate> {
            return localVarFp.createPolicyTemplate(requestParameters.policyTemplateCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Policy Template Version
         * @param {PolicyTemplatesApiCreatePolicyTemplateVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyTemplateVersion(requestParameters: PolicyTemplatesApiCreatePolicyTemplateVersionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplateVersion> {
            return localVarFp.createPolicyTemplateVersion(requestParameters.policyTemplateId, requestParameters.policyTemplateVersionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Policy Template
         * @param {PolicyTemplatesApiGetPolicyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyTemplate(requestParameters: PolicyTemplatesApiGetPolicyTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplate> {
            return localVarFp.getPolicyTemplate(requestParameters.policyTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Policy Template Version
         * @param {PolicyTemplatesApiGetPolicyTemplateVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyTemplateVersion(requestParameters: PolicyTemplatesApiGetPolicyTemplateVersionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplateVersion> {
            return localVarFp.getPolicyTemplateVersion(requestParameters.policyTemplateVersionId, requestParameters.policyTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Policy Template Version Frameworks
         * @param {PolicyTemplatesApiGetPolicyTemplateVersionFrameworksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyTemplateVersionFrameworks(requestParameters: PolicyTemplatesApiGetPolicyTemplateVersionFrameworksRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PlatformFramework>> {
            return localVarFp.getPolicyTemplateVersionFrameworks(requestParameters.policyTemplateVersionId, requestParameters.policyTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query Policy Template Versions
         * @param {PolicyTemplatesApiQueryPolicyTemplateVersionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicyTemplateVersions(requestParameters: PolicyTemplatesApiQueryPolicyTemplateVersionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplateVersionPaginated> {
            return localVarFp.queryPolicyTemplateVersions(requestParameters.policyTemplateId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query Policy Templates
         * @param {PolicyTemplatesApiQueryPolicyTemplatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicyTemplates(requestParameters: PolicyTemplatesApiQueryPolicyTemplatesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplatePaginated> {
            return localVarFp.queryPolicyTemplates(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrDescription, requestParameters.status, requestParameters.platformFrameworkIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Query Policy Templates Expanded
         * @param {PolicyTemplatesApiQueryPolicyTemplatesExpandedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryPolicyTemplatesExpanded(requestParameters: PolicyTemplatesApiQueryPolicyTemplatesExpandedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplateOverviewPaginated> {
            return localVarFp.queryPolicyTemplatesExpanded(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.createdById, requestParameters.draftPolicyTemplateVersionStatus, requestParameters.nameOrDescription, requestParameters.status, requestParameters.platformFrameworkIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Framework from Policy Template Version
         * @param {PolicyTemplatesApiRemovePlatformFrameworkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePlatformFramework(requestParameters: PolicyTemplatesApiRemovePlatformFrameworkRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplateVersion> {
            return localVarFp.removePlatformFramework(requestParameters.platformFrameworkId, requestParameters.policyTemplateId, requestParameters.policyTemplateVersionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace All Frameworks of Policy Template Version
         * @param {PolicyTemplatesApiUpdatePlatformFrameworksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlatformFrameworks(requestParameters: PolicyTemplatesApiUpdatePlatformFrameworksRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplateVersion> {
            return localVarFp.updatePlatformFrameworks(requestParameters.policyTemplateId, requestParameters.policyTemplateVersionId, requestParameters.policyTemplateVersionFrameworksUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Policy Template Status
         * @param {PolicyTemplatesApiUpdatePolicyTemplateStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyTemplateStatus(requestParameters: PolicyTemplatesApiUpdatePolicyTemplateStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplate> {
            return localVarFp.updatePolicyTemplateStatus(requestParameters.policyTemplateId, requestParameters.policyTemplateStatusUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Policy Template Version
         * @param {PolicyTemplatesApiUpdatePolicyTemplateVersionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyTemplateVersion(requestParameters: PolicyTemplatesApiUpdatePolicyTemplateVersionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplateVersion> {
            return localVarFp.updatePolicyTemplateVersion(requestParameters.policyTemplateId, requestParameters.policyTemplateVersionId, requestParameters.policyTemplateVersionUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Policy Template Version Status
         * @param {PolicyTemplatesApiUpdatePolicyTemplateVersionStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyTemplateVersionStatus(requestParameters: PolicyTemplatesApiUpdatePolicyTemplateVersionStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolicyTemplateVersion> {
            return localVarFp.updatePolicyTemplateVersionStatus(requestParameters.policyTemplateId, requestParameters.policyTemplateVersionId, requestParameters.policyTemplateVersionStatusUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addPlatformFramework operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiAddPlatformFrameworkRequest {
    readonly policyTemplateId: string

    readonly policyTemplateVersionId: string

    readonly policyTemplateVersionFrameworkUpdate: PolicyTemplateVersionFrameworkUpdate
}

/**
 * Request parameters for createPolicyTemplate operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiCreatePolicyTemplateRequest {
    readonly policyTemplateCreate: PolicyTemplateCreate
}

/**
 * Request parameters for createPolicyTemplateVersion operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiCreatePolicyTemplateVersionRequest {
    readonly policyTemplateId: string

    readonly policyTemplateVersionCreate: PolicyTemplateVersionCreate
}

/**
 * Request parameters for getPolicyTemplate operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiGetPolicyTemplateRequest {
    readonly policyTemplateId: string
}

/**
 * Request parameters for getPolicyTemplateVersion operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiGetPolicyTemplateVersionRequest {
    readonly policyTemplateVersionId: string

    readonly policyTemplateId: string
}

/**
 * Request parameters for getPolicyTemplateVersionFrameworks operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiGetPolicyTemplateVersionFrameworksRequest {
    readonly policyTemplateVersionId: string

    readonly policyTemplateId: string
}

/**
 * Request parameters for queryPolicyTemplateVersions operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiQueryPolicyTemplateVersionsRequest {
    readonly policyTemplateId: string

    readonly page?: number

    readonly size?: number

    readonly sortBy?: PolicyTemplateVersionSorting | null

    readonly descending?: boolean | null
}

/**
 * Request parameters for queryPolicyTemplates operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiQueryPolicyTemplatesRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: PolicyTemplateSorting | null

    readonly descending?: boolean | null

    readonly nameOrDescription?: string | null

    readonly status?: PolicyTemplateStatus | null

    /**
     * Filter by platform framework IDs.
     */
    readonly platformFrameworkIds?: Array<string> | null
}

/**
 * Request parameters for queryPolicyTemplatesExpanded operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiQueryPolicyTemplatesExpandedRequest {
    readonly page?: number

    readonly size?: number

    readonly sortBy?: PolicyTemplateExpandedSorting | null

    readonly descending?: boolean | null

    readonly createdById?: string | null

    readonly draftPolicyTemplateVersionStatus?: PolicyTemplateVersionStatus | null

    readonly nameOrDescription?: string | null

    readonly status?: PolicyTemplateStatus | null

    /**
     * Filter by platform framework IDs.
     */
    readonly platformFrameworkIds?: Array<string> | null
}

/**
 * Request parameters for removePlatformFramework operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiRemovePlatformFrameworkRequest {
    readonly platformFrameworkId: string

    readonly policyTemplateId: string

    readonly policyTemplateVersionId: string
}

/**
 * Request parameters for updatePlatformFrameworks operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiUpdatePlatformFrameworksRequest {
    readonly policyTemplateId: string

    readonly policyTemplateVersionId: string

    readonly policyTemplateVersionFrameworksUpdate: PolicyTemplateVersionFrameworksUpdate
}

/**
 * Request parameters for updatePolicyTemplateStatus operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiUpdatePolicyTemplateStatusRequest {
    readonly policyTemplateId: string

    readonly policyTemplateStatusUpdate: PolicyTemplateStatusUpdate
}

/**
 * Request parameters for updatePolicyTemplateVersion operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiUpdatePolicyTemplateVersionRequest {
    readonly policyTemplateId: string

    readonly policyTemplateVersionId: string

    readonly policyTemplateVersionUpdate: PolicyTemplateVersionUpdate
}

/**
 * Request parameters for updatePolicyTemplateVersionStatus operation in PolicyTemplatesApi.
 */
export interface PolicyTemplatesApiUpdatePolicyTemplateVersionStatusRequest {
    readonly policyTemplateId: string

    readonly policyTemplateVersionId: string

    readonly policyTemplateVersionStatusUpdate: PolicyTemplateVersionStatusUpdate
}

/**
 * PolicyTemplatesApi - object-oriented interface
 */
export class PolicyTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Add Framework to Policy Template Version
     * @param {PolicyTemplatesApiAddPlatformFrameworkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addPlatformFramework(requestParameters: PolicyTemplatesApiAddPlatformFrameworkRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).addPlatformFramework(requestParameters.policyTemplateId, requestParameters.policyTemplateVersionId, requestParameters.policyTemplateVersionFrameworkUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Policy Template
     * @param {PolicyTemplatesApiCreatePolicyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPolicyTemplate(requestParameters: PolicyTemplatesApiCreatePolicyTemplateRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).createPolicyTemplate(requestParameters.policyTemplateCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Policy Template Version
     * @param {PolicyTemplatesApiCreatePolicyTemplateVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPolicyTemplateVersion(requestParameters: PolicyTemplatesApiCreatePolicyTemplateVersionRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).createPolicyTemplateVersion(requestParameters.policyTemplateId, requestParameters.policyTemplateVersionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Policy Template
     * @param {PolicyTemplatesApiGetPolicyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyTemplate(requestParameters: PolicyTemplatesApiGetPolicyTemplateRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).getPolicyTemplate(requestParameters.policyTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Policy Template Version
     * @param {PolicyTemplatesApiGetPolicyTemplateVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyTemplateVersion(requestParameters: PolicyTemplatesApiGetPolicyTemplateVersionRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).getPolicyTemplateVersion(requestParameters.policyTemplateVersionId, requestParameters.policyTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Policy Template Version Frameworks
     * @param {PolicyTemplatesApiGetPolicyTemplateVersionFrameworksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPolicyTemplateVersionFrameworks(requestParameters: PolicyTemplatesApiGetPolicyTemplateVersionFrameworksRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).getPolicyTemplateVersionFrameworks(requestParameters.policyTemplateVersionId, requestParameters.policyTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query Policy Template Versions
     * @param {PolicyTemplatesApiQueryPolicyTemplateVersionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryPolicyTemplateVersions(requestParameters: PolicyTemplatesApiQueryPolicyTemplateVersionsRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).queryPolicyTemplateVersions(requestParameters.policyTemplateId, requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query Policy Templates
     * @param {PolicyTemplatesApiQueryPolicyTemplatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryPolicyTemplates(requestParameters: PolicyTemplatesApiQueryPolicyTemplatesRequest = {}, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).queryPolicyTemplates(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.nameOrDescription, requestParameters.status, requestParameters.platformFrameworkIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Query Policy Templates Expanded
     * @param {PolicyTemplatesApiQueryPolicyTemplatesExpandedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public queryPolicyTemplatesExpanded(requestParameters: PolicyTemplatesApiQueryPolicyTemplatesExpandedRequest = {}, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).queryPolicyTemplatesExpanded(requestParameters.page, requestParameters.size, requestParameters.sortBy, requestParameters.descending, requestParameters.createdById, requestParameters.draftPolicyTemplateVersionStatus, requestParameters.nameOrDescription, requestParameters.status, requestParameters.platformFrameworkIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Framework from Policy Template Version
     * @param {PolicyTemplatesApiRemovePlatformFrameworkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removePlatformFramework(requestParameters: PolicyTemplatesApiRemovePlatformFrameworkRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).removePlatformFramework(requestParameters.platformFrameworkId, requestParameters.policyTemplateId, requestParameters.policyTemplateVersionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace All Frameworks of Policy Template Version
     * @param {PolicyTemplatesApiUpdatePlatformFrameworksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePlatformFrameworks(requestParameters: PolicyTemplatesApiUpdatePlatformFrameworksRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).updatePlatformFrameworks(requestParameters.policyTemplateId, requestParameters.policyTemplateVersionId, requestParameters.policyTemplateVersionFrameworksUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Policy Template Status
     * @param {PolicyTemplatesApiUpdatePolicyTemplateStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePolicyTemplateStatus(requestParameters: PolicyTemplatesApiUpdatePolicyTemplateStatusRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).updatePolicyTemplateStatus(requestParameters.policyTemplateId, requestParameters.policyTemplateStatusUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Policy Template Version
     * @param {PolicyTemplatesApiUpdatePolicyTemplateVersionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePolicyTemplateVersion(requestParameters: PolicyTemplatesApiUpdatePolicyTemplateVersionRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).updatePolicyTemplateVersion(requestParameters.policyTemplateId, requestParameters.policyTemplateVersionId, requestParameters.policyTemplateVersionUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Policy Template Version Status
     * @param {PolicyTemplatesApiUpdatePolicyTemplateVersionStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePolicyTemplateVersionStatus(requestParameters: PolicyTemplatesApiUpdatePolicyTemplateVersionStatusRequest, options?: RawAxiosRequestConfig) {
        return PolicyTemplatesApiFp(this.configuration).updatePolicyTemplateVersionStatus(requestParameters.policyTemplateId, requestParameters.policyTemplateVersionId, requestParameters.policyTemplateVersionStatusUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

